import React from 'react';
import StatsPage from '../../table/components/StatsPage';
import { Button } from 'antd';

import { connect } from 'react-redux';
import { actions, selectors } from 'farmx-redux-core';

const { loadSensorNotesList } = actions;
const {
  selectAllSensorNotes,
  selectLoadingSensorNotes,
} = selectors;

const columns = [
  'date',
  'sensor',
  'identifier',
  'action',
  'text',
  'username',
];

export class SensorNotesPage extends React.Component {

  constructor(props) {
    super(props);

    const params = new URLSearchParams(props.location.search);
    const urlFilters = {};

    for (const [key, value] of params.entries()) {
      urlFilters[key] = {
        filterType: "text",
        type: "equals",
        filter: value,
      };
    };

    const defaultFilters = {};
    const filters = Array.from(params).length ? urlFilters : defaultFilters;

    this.state = {
      filters,
      sort: [
        { colId: 'date', sort: 'dsc' },
      ],
    };
  }

  showCreateNote = () => {
    const { history } = this.props;
    history.push("/notes/create");
  };

  clearFilters = () => {
    this.setState({
      filters: {},
      sort: null,
    });
  };

  filtersChanged = (filters) => {
    this.setState({
      filters: filters,
    });
  };

  render () {
    const { filters, sort } = this.state;
    const { lastUpdated, data, loading, loadData } = this.props;
    return (
      <StatsPage
        title="Sensor Notes"
        columns={ columns }
        loadData={loadData}  
        data={lastUpdated ? data : undefined}
        loading={loading}
        lastUpdated={lastUpdated}
        filters={ filters }
        sort={ sort }
        filtersChangedCallback={ this.filtersChanged }
        sizeToFit
        extra={[
          <Button type="primary" key="create-note" onClick={this.showCreateNote}>Create Note</Button>
        ]}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const notes = selectAllSensorNotes(state);
  const sensorNotesLoading = selectLoadingSensorNotes(state);
  const { loading, lastUpdated } = sensorNotesLoading;

  return {
    loading,
    lastUpdated,
    data: notes,
  }
};

const mapDispatchToProps = {
  loadData: loadSensorNotesList,
};

export default connect(mapStateToProps, mapDispatchToProps)(SensorNotesPage);
